import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TourMatMenu } from 'ngx-ui-tour-md-menu';
import { PortfolioSeries } from 'src/app/models/classes/portfolio-series.class';
import { AssetClassPipe } from 'src/app/pipes/asset-class.pipe';
import { DateFormatPipe } from 'src/app/pipes/date-format.pipe';
import { SeriesSummaryCardComponent } from '../series-summary-card/series-summary-card.component';
import { Portfolio } from 'src/app/models/classes/portfolio.class';

@Component({
  selector: 'app-series-dashboard-summary',
  imports: [
    CommonModule,
    MatTooltipModule,
    DateFormatPipe,
    TourMatMenu,
    SeriesSummaryCardComponent
  ],
  templateUrl: './series-dashboard-summary.component.html'
})
export class SeriesDashboardSummaryComponent {
  private assetClassPipe = inject(AssetClassPipe);

  readonly portfolioSummary = input.required<Portfolio>();
  readonly seriesSummary = input.required<PortfolioSeries>();
  readonly iconSet = input.required<Record<string, string>>();
  readonly selectedAsOfDate = input.required<string>();
  readonly seriesName = input.required<string>();
  readonly isPortfolioSeriesDataUnavailable = input.required<boolean>();
  readonly reportingPeriodChange = output<string>();
  readonly snapShotBtnClick = output();
  readonly assetClassImage = computed<string[][]>(() => {
    const seriesSummary = this.seriesSummary();
    const iconSet = this.iconSet();
    const result: string[][] = [];
    if (!seriesSummary) return result;

    if(seriesSummary.assetClass === 'ARS') {
      seriesSummary.assetClass = 'Absolute Returns Strategy';
    }

    if(seriesSummary.assetClass) {
      result.push([seriesSummary.assetClass, iconSet[this.assetClassPipe.transform(seriesSummary.assetClass) as string]]);
    }
    return result;
  });
}
